import type { IPageFilters } from "./Types";

export const tableFilterChange = (filter: Partial<IPageFilters>) => {
    const filters = Object.entries(filter);
    const filtersToRemove = filters.filter(([_, value]) => value == null).map(([key]) => key);
    const filtersToAdd = Object.fromEntries(filters.filter(([_, value]) => value != null));
    return (state) => ({
        ...Object.fromEntries(Object.entries(state).filter(([name]) => !filtersToRemove.includes(name))),
        ...filtersToAdd,
    });
};
